import { resolveContentfulEventType } from '@wbk/contentful';
import { ContentfulEvent, WebSection } from '@wbk/contentful/api';
import { WebItem } from '@/components/sections/common/EventSection';
import { WebSectionItem } from '../../../../packages/contentful/dist/types';
import { logger } from '../../logger.config';

export const getWebookRedirectUrl = (url: string) => {
  try {
    const safeUrl = url.startsWith('http')
      ? url
      : url.startsWith('/')
        ? `https://webook.com${url}`
        : `https://webook.com/${url}`;
    const urlObj = new URL(safeUrl);
    const wbkUrl = `${process.env.VITE_PUBLIC_BOOK_DOMAIN}${urlObj.pathname}${urlObj.search}`;
    return wbkUrl;
  } catch (error) {
    logger.captureException(new Error('getWebookRedirectUrlException'), { extra: { url } });
    return '/';
  }
};

export const getEventRedirectUrl = (
  item: WebSection['contentCollection']['items'][0] | ContentfulEvent,
  slug: string,
  locale: string,
  parsed: WebSectionItem | WebItem,
  utm?: string
) => {
  const typename = item.__typename;

  const eventType = resolveContentfulEventType(typename);
  // we can enable experiences later we already have a page for it
  const isLocalEvent = /* eventType === 'experiences' ||*/ eventType === 'events';

  const webookLink = !isLocalEvent
    ? isLocalEvent
      ? `/${locale}/${eventType}/${slug}`
      : `https://webook.com/${locale}/${eventType}/${slug}/`
    : null;

  const isExternal = !isLocalEvent ? true : parsed.href?.startsWith('http');
  const href = !isLocalEvent ? webookLink : parsed.href ? `${parsed.href}${utm || ''}` : '#';

  return {
    href,
    isExternal,
  };
};

export const getWebookUrl = (locale: string) => {
  return process.env.VITE_PUBLIC_ENV !== 'production'
    ? `https://wbk-web-lap.webook.rocks/${locale}`
    : `https://webook.com/${locale}`;
};

export function isExternalUrl(url: string): boolean {
  return /^(https?:)?\/\//i.test(url) || /^www\./i.test(url);
}
